import * as basic from '../../../config/basic'
export const rule = {
  applyRule: {
    title: '报名规则',
    titleBg: require('@/assets/img/title-bg.png'),
    descTitle: '本届竞赛面向国内及海外高校在读学生。具体要求如下：',
    list: [
      {
        img: require('@/assets/transSave/resource/image/yy/9a/yybd38c15eb4e42611a7c44a1ef3669a.png'),
        text: '参赛团队全员须为全国高校和科研院所的全日制在校大学生（包括本科生、研究生及博士生），专业、年级、学历不限。'
      },
      {
        img: require('@/assets/transSave/resource/image/5a/5d/5a74c019ba1bb19cdcede3598ea51a5d.png'),
        text: '须以团队的形式参赛，每支参赛队伍人数2-5人，允许跨年级、跨专业、跨校组队。如有个人参赛者，可先提交报名，大赛组委会将提供交流平台协助组队。'
      },
      {
        img: require('@/assets/transSave/resource/image/b6/4a/b6f1097cc09784fe49f9303bc7a44d4a.png'),
        text: '参赛队员需保证报名信息真实、准确、有效，每人只能参加一支队伍，重复报名无效。'
      },
      {
        img: require('@/assets/transSave/resource/image/06/16/0647e1fbe452dfd9622d2b9c82440716.png'),
        text: '参赛队伍需独立完成题目，符合相关法律、法规规定，无任何作弊、欺诈、侵犯他人知识产权等行为。参赛期间若经发现或被举报并核实存在上述行为，大赛组委会有权取消参赛队伍的参赛资格和比赛成绩。'
      },
      {
        img: require('@/assets/transSave/resource/image/9e/38/9efa43a5048091e17b108af2cd252c38.png'),
        text: '本次大赛参赛作品的知识产权归参赛选手所有，主办方有权将参赛作品及作品相关、参赛队伍等信息用于宣传品、相关出版物、指定及授权媒体发布、官方网站浏览及下载、展览（含巡展）等。'
      },
      {
        img: require('@/assets/transSave/resource/image/f0/ef/f0fb45b7f7e5c34c0923189339df75ef.png'),
        text: '本次竞赛不收取任何报名费用，受邀参加决赛的参赛队员，决赛期间的食宿及往返交通费用由大赛组委会统一安排，相关政策请见后续具体通知。'
      }
    ],
    // warn: '* 基于政策和监管要求，区块链赛道参赛作品智能合约代码中不得出现 coin、token 等字眼，功能层面不得出现代币、Defi、NFT 等场景。',
    group: {
      qq: {
        qqImg: require('@/assets/transSave/resource/image/1e/eb/1e5ca15777845fce6429b368f12c99eb.png'),
        qqText: '大赛交流QQ群'
      },
      wx: {
        list: [
          {
          img: require('@/assets/img/ai-assistant-qr-2026.png'),
            text: '人工智能小助手'
          },
          {
            img: require('@/assets/img/数据分析小助手二维码.jpg'),
            text: '数据分析小助手'
          },
          // {
          //   img: require('@/assets/img/qr-cp1.png'),
          //   text: '产品经理小助手'
          // }
        ],
        wxText: '扫码添加小助手，进入微信群'
      },
      email: {
        list: [
          {
            emailImg: require('@/assets/transSave/resource/image/bb/93/bb880ba8b8fcfd54f03d74c95d699c93.png'),
            emailText: '人工智能赛道邮箱联系：fintechathon@g-ican.com'
          },
          {
            emailImg: require('@/assets/transSave/resource/image/bb/93/bb880ba8b8fcfd54f03d74c95d699c93.png'),
            emailText: '数据分析赛道邮箱联系：clubear@clubear.org'
          }
        ]
      }
    }
  },
  process: {
    title: '参赛流程',
    titleBg: require('@/assets/img/title-bg.png'),
    main: {
      left: [
        {
          list: {
            title: '01、报名',
            content: '参赛队伍由队长登录大赛官网按要求提交团队名称、联系方式等信息，完成报名。'
          }
        },
        {
          list: {
            title: '03、修改和完善作品',
            content: '在初赛规定时间内，参赛队伍可在不更改作品主题的前提下，对其参赛作品进行完善，最终参赛作品以初赛规定的时间内最后一次提交的版本为准，作品提交总次数不超过3次。'
          }
        },
        {
          list: {
            title: '05、36小时编程马拉松',
            content: '人工智能赛道和区块链赛道将采用36小时封闭马拉松的形式对初赛提交的作品进行开发和完善，并参与现场路演答辩。决赛作品必须使用大赛规定的开源系统（人工智能赛道使用FATE平台，区块链赛道使用FISCO BCOS平台）'
          }
        }
      ],
      centerLine: require('@/assets/transSave/resource/image/84/fd/8416d2219b8c6dcf70c40f028e10e1fd.png'),
      right: [
        {
          list: {
            title: '02、提交初赛参赛作品',
            content: '在初赛规定时间内，由队长登录提交页面，提交初赛作品（包括但不限于产品说明、功能特色、技术开发方案、商业应用场景及价值、团队分工等内容）。<br /><br /><span style="color: #000000; font-weight: 600">初赛作品需包含：</span><br />1、作品介绍（PPT.）2、作品技术文档（DOC.）<br />3、作品展示材料。<br /><br /><span style="color: #000000; font-weight: 600">产品经理赛道的初赛作品提交：</span><br />1、作品介绍（PPT）+ 产品设计文档（doc)  (文档包括但不限于项目背景、产品价值、产品流程、功能说明）。'
          }
        },
        {
          list: {
            title: '04、决赛选拔',
            content: '大赛组委会将评审选拔出三个赛道共30支队伍入围，前往深圳参加现场决赛<br /><br />* 决赛作品的整体方向需与初赛作品一致，不得临时调整方向。<br /><br />* 如受疫情影响，决赛将调整为线上进行，大赛组委会将通过短信、邮箱和官网公告等形式通知。'
          }
        },
        {
          list: {
            title: '06、现场答辩',
            content: '产品经理赛道将采用现场答辩形式，展示项目介绍、产品流程及功能说明。'
          }
        }
      ],
      award: {
        title: '颁奖礼',
        img: require('@/assets/transSave/resource/image/2f/42/2f0abd0faa801c06a3601d5d8ea79942.png'),
        content: '人工智能赛道和区块链赛道现场决赛、产品经理赛道现场答辩结束后，各赛道将决出冠军、亚军、季军，每个赛道前三名的获奖团队将在现场进行作品展示。'
      }
    }
  },
  reviewRule: {
    title: '评审规则',
    titleBg: require('@/assets/img/title-bg.png'),
    main: [
      {
        type: 'ai',
        titleImg: basic.aiLogoBg,
        title: '人工智能赛道评审规则',
        titleMobile: '人工智能',
        titleColor: '#E1574D',
        titleBgColor: '253, 218, 216',
        list: [
          {
            percent: '40%',
            title: '产品实现完整性',
            // desc: '考察作品实际完成程度，包括代码实现和提交'
          },
          {
            percent: '30%',
            title: '创新性',
            // desc: '考察作品创意、亮点，交互设计、用户体验等'
          },
          {
            percent: '30%',
            title: '商业价值',
            // desc: '考察作品市场可用性、可延展性，以及与数字银行应用的结合度等'
          }
        ]
      },
      {
        type: 'blockchain',
        titleImg: basic.blockchainLogoBg,
        title: '数据分析赛道评审规则',
        titleMobile: '数据分析',
        titleColor: '#7550E1',
        titleBgColor: '235, 227, 255',
        list: [
          {
            percent: '30%',
            title: '数据建模与解读',
          },
          {
            percent: '20%',
            title: '数据说明与描述',
          },
          {
            percent: '20%',
            title: '研究背景的介绍',
          },
          {
            percent: '20%',
            title: '商业化应用',
          },
          {
            percent: '10%',
            title: 'AI 创新程度',
          },
        ]
      },
    ]
  },
  unit: {
    title: '实习面试直通车',
    titleBg: require('@/assets/img/title-bg.png'),
    list: [
      {
        id: '0',
        title: '微众银行',
        img: require('@/assets/transSave/resource/image/d7/00/d7bbe256b419a4e5c0d702e6f8880e00.png'),
        practiceList: [
          {
            name: '数据分析-风险管理方向',
            member: '需求人数：3人'
          },
          {
            name: '数据挖掘',
            member: '需求人数：2人'
          },
          {
            name: '产品经理-金融产品方向',
            member: '需求人数：3人'
          }
        ]
      },
      {
        id: '1',
        title: '华润银行',
        img: require('@/assets/transSave/resource/image/52/94/52a177b4d2ef47446c722ae4147f7c94.png'),
        practiceList: [
          {
            name: '总行智能科技部-智能科技类实习岗',
            member: '需求人数：10人'
          }
        ]
      },
      {
        id: '2',
        title: '江南农村商业银行',
        img: require('@/assets/transSave/resource/image/f3/48/f30f79bbcaff0473c5e1a525yya01648.png'),
        practiceList: [
          {
            name: '安全技术岗',
            member: '需求人数：4人'
          },
          {
            name: '产品经理岗',
            member: '需求人数：2人'
          },
          {
            name: '数据建模岗',
            member: '需求人数：2人'
          },
          {
            name: '安全技术岗',
            member: '需求人数：2人'
          }
        ]
      },
      {
        id: '3',
        title: '平安银行 信用卡',
        img: require('@/assets/transSave/resource/image/44/51/4462c6f1decda9970e5dd08c9d23cf51.png'),
        practiceList: [
          {
            name: '业务推动类实习岗',
            member: '需求人数：5人'
          },
          {
            name: '市场营销类实习岗',
            member: '需求人数：5人'
          },
          {
            name: '运营类实习岗',
            member: '需求人数：2人'
          },
          {
            name: '科技类实习岗',
            member: '需求人数：2人'
          }
        ]
      },
      {
        id: '4',
        title: '金证股份',
        img: require('@/assets/transSave/resource/image/d4/25/d47c27bab1be3ec15a3b9df041951d25.png'),
        practiceList: [
          {
            name: 'C/C++开发工程师',
            member: '需求人数：4人'
          },
          {
            name: 'JAVA开发工程师',
            member: '需求人数：3人'
          },
          {
            name: 'WEB开发工程师',
            member: '需求人数：3人'
          }
        ]
      },
      {
        id: '5',
        title: '安信证券',
        img: require('@/assets/transSave/resource/image/10/84/10f4342ccd28419e40f9deaa51a81d84.png'),
        practiceList: [
          {
            name: '信息技术委员会运维岗',
            member: '需求人数：3人'
          },
          {
            name: '信息技术委员会测试岗',
            member: '需求人数：3人'
          },
          {
            name: '信息技术委员会开发岗',
            member: '需求人数：3人'
          },
          {
            name: '信息技术委员会产品经理岗',
            member: '需求人数：1人'
          }
        ]
      },
      {
        id: '6',
        title: '第一创业证券',
        img: require('@/assets/transSave/resource/image/f3/97/f31962262d9b496f3407b5a05de75697.png'),
        practiceList: [
          {
            name: '大数据挖掘岗',
            member: '需求人数：1人'
          },
          {
            name: 'JAVA开发岗',
            member: '需求人数：3人'
          },
          {
            name: 'C++开发岗',
            member: '需求人数：1人'
          },
          {
            name: '前端开发岗',
            member: '需求人数：1人'
          },
          {
            name: '产品经理岗',
            member: '需求人数：1人'
          },
          {
            name: '系统测试岗',
            member: '需求人数：3人'
          }
        ]
      },
      {
        id: '7',
        title: '德科信息',
        img: require('@/assets/transSave/resource/image/ed/33/eda7a1fa0b7fcdaa6f15a5ac56232133.png'),
        practiceList: [
          {
            name: '前端开发工程师',
            member: '需求人数：2人'
          },
          {
            name: '后台开发工程师',
            member: '需求人数：4人'
          },
          {
            name: '软件测试工程师',
            member: '需求人数：2人'
          },
          {
            name: '数据分析师',
            member: '需求人数：1人'
          },
          {
            name: '客户经理',
            member: '需求人数：2人'
          }
        ]
      },
      {
        id: '8',
        title: '国家金融科技评测中心',
        img: require('@/assets/transSave/resource/image/be/66/bea09c4ba75cd99c1c1e2f28b0a30966.png'),
        practiceList: [
          {
            name: '技术实习生',
            member: '需求人数：4人'
          },
          {
            name: '全栈开发实习生',
            member: '需求人数：2人'
          },
          {
            name: '安全检测实习生',
            member: '需求人数：1人'
          },
          {
            name: '综合实习生',
            member: '需求人数：1人'
          },
          {
            name: 'Android开发工程师',
            member: '需求人数：1人'
          },
          {
            name: 'OpenHarmonyOS研发工程师',
            member: '需求人数：1人'
          },
          {
            name: '区块链研发工程师',
            member: '需求人数：1人'
          },
          {
            name: '嵌入式硬件工程师',
            member: '需求人数：1人'
          },
          {
            name: '应用软件工程师',
            member: '需求人数：1人'
          }
        ]
      },
      {
        id: '9',
        title: '华策数科',
        img: require('@/assets/transSave/resource/image/c9/ab/c90920c6ee03c70231e1b1575e1824ab.png'),
        practiceList: [
          {
            name: 'JAVA后端开发工程师',
            member: '需求人数：4人'
          },
          {
            name: '测试工程师',
            member: '需求人数：3人'
          },
          {
            name: '数据挖掘工程师',
            member: '需求人数：3人'
          }
        ]
      },
      {
        id: '10',
        title: '微言科技',
        img: require('@/assets/transSave/resource/image/89/e1/89e4e26e5a98ea7c342ea2ece8396ce1.png'),
        practiceList: [
          {
            name: 'WEB前端开发工程师',
            member: '需求人数：3人'
          },
          {
            name: 'JAVA开发工程师',
            member: '需求人数：3人'
          },
          {
            name: '密码学工程师',
            member: '需求人数：2人'
          }
        ]
      }
    ],
    warning: '*点击对应企业了解岗位详情<br />以上实习或者面试直通卡均提供给进入决赛选手，双向选择以最终面试为主'
  },
  notice: {
    title: '赛事声明',
    titleBg: require('@/assets/img/title-bg.png'),
    list: [
      {
        id: '01',
        text: '为了确保整个大赛顺利、公正地进行，以及保证参赛选手的合法权益，参赛选手报名时应阅读和确认大赛官网上的参赛规则，自觉遵守规则约定。'
      },
      {
        id: '02',
        text: '在大赛举办过程中，竞赛规程可能会有少量的变更和调整，所有内容均以大赛官网为准。'
      },
      {
        id: '03',
        text: '本大赛规程的最终解释权归“深圳国际金融科技大赛”组委会所有。'
      }
    ],
    place: '深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛',
    time: '2025年9月'
  }
}
